import React, { useState } from "react";

import {
  X,
  Calendar,
  FileText,
} from "lucide-react";

import generateClientStatement
from "./utils/generateClientStatement";

const StatementExportModal = ({
  isOpen,
  onClose,
  client,
  invoices,
  payments,
  totalOutstanding,
  totalPaid,
}) => {

  const [statementType, setStatementType] =
    useState("current");

  const [startDate, setStartDate] =
    useState("");

  const [endDate, setEndDate] =
    useState("");

  if (!isOpen) return null;

  // =========================================
  // FILTER LOGIC
  // =========================================

  const getFilteredData = () => {

    let filteredInvoices = invoices;
    let filteredPayments = payments;

    const now = new Date();

    // CURRENT MONTH

    if (statementType === "current") {

      filteredInvoices =
        invoices.filter((inv) => {

          const d = new Date(
            inv.date_created
          );

          return (
            d.getMonth() ===
              now.getMonth() &&
            d.getFullYear() ===
              now.getFullYear()
          );
        });

      filteredPayments =
        payments.filter((p) => {

          const d = new Date(
            p.payment_date
          );

          return (
            d.getMonth() ===
              now.getMonth() &&
            d.getFullYear() ===
              now.getFullYear()
          );
        });
    }

    // PREVIOUS MONTH

    if (statementType === "previous") {

      const previousMonth =
        now.getMonth() - 1;

      filteredInvoices =
        invoices.filter((inv) => {

          const d = new Date(
            inv.date_created
          );

          return (
            d.getMonth() ===
              previousMonth &&
            d.getFullYear() ===
              now.getFullYear()
          );
        });

      filteredPayments =
        payments.filter((p) => {

          const d = new Date(
            p.payment_date
          );

          return (
            d.getMonth() ===
              previousMonth &&
            d.getFullYear() ===
              now.getFullYear()
          );
        });
    }

    // CUSTOM RANGE

    if (
      statementType === "custom" &&
      startDate &&
      endDate
    ) {

      const start =
        new Date(startDate);

      const end =
        new Date(endDate);

      filteredInvoices =
        invoices.filter((inv) => {

          const d = new Date(
            inv.date_created
          );

          return (
            d >= start &&
            d <= end
          );
        });

      filteredPayments =
        payments.filter((p) => {

          const d = new Date(
            p.payment_date
          );

          return (
            d >= start &&
            d <= end
          );
        });
    }

    return {
      filteredInvoices,
      filteredPayments,
    };
  };

  // =========================================
  // GENERATE
  // =========================================

  const handleGenerate = () => {

    const {
      filteredInvoices,
      filteredPayments,
    } = getFilteredData();

    generateClientStatement({

      client,

      invoices:
        filteredInvoices,

      payments:
        filteredPayments,

      totalOutstanding,

      totalPaid,

      statementType,

      startDate,

      endDate,
    });

  };

  return (
    <div className="modern-modal-overlay">

      <div className="modern-modal statement-modal">

        {/* HEADER */}

        <div className="modern-modal-header">

          <div>

            <h2>
              Generate Statement
            </h2>

            <p>
              {client.name}
            </p>

          </div>

          <button
            className="close-btn"
            onClick={onClose}
          >
            <X size={18} />
          </button>

        </div>

        {/* OPTIONS */}

        <div className="statement-options">

          <button
            className={
              statementType === "current"
                ? "statement-active"
                : ""
            }
            onClick={() =>
              setStatementType(
                "current"
              )
            }
          >
            Current Month
          </button>

          <button
            className={
              statementType === "previous"
                ? "statement-active"
                : ""
            }
            onClick={() =>
              setStatementType(
                "previous"
              )
            }
          >
            Previous Month
          </button>

          <button
            className={
              statementType === "custom"
                ? "statement-active"
                : ""
            }
            onClick={() =>
              setStatementType(
                "custom"
              )
            }
          >
            Custom Range
          </button>

        </div>

        {/* CUSTOM RANGE */}

        {statementType === "custom" && (

          <div className="statement-date-grid">

            <div className="modern-input-group">

              <label>
                <Calendar size={16} />
                Start Date
              </label>

              <input
                type="date"
                value={startDate}
                onChange={(e) =>
                  setStartDate(
                    e.target.value
                  )
                }
              />

            </div>

            <div className="modern-input-group">

              <label>
                <Calendar size={16} />
                End Date
              </label>

              <input
                type="date"
                value={endDate}
                onChange={(e) =>
                  setEndDate(
                    e.target.value
                  )
                }
              />

            </div>

          </div>

        )}

        {/* GENERATE */}

        <button
          className="submit-modern-btn"
          onClick={handleGenerate}
        >

          <FileText size={18} />

          Generate Statement

        </button>

      </div>

    </div>
  );
};

export default StatementExportModal;